import { MotorbikeOffIcon } from './MotorbikeOffIcon';

/**
 * author: Michael Irigoyen
 * id E048C1A8-480D-4289-B026-9D1C64BA4236
 * name motorbike-off
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/motorbike-off.svg
 * tags
 * - Transportation + Road 
 */
export const MotorcycleOffIcon = MotorbikeOffIcon;
export default MotorcycleOffIcon